export const getSigninWithPasscodeConfig = (step: number, identifier: string) => {
	const configs = {
		1: {
			title: "Sign in with OTP",
			subtitle: "Use your email or phone number and Passcode to sign in",
		}
	};
	return configs[step as keyof typeof configs];
};